import $ from 'jquery'

const selectorFormular = '.page-gewinnspiel-formular form'
const selectorTextfield = '#upload-textfield'
const selectorUserfile = '#upload-userfile'
const idUserfile = 'upload-userfile'
const selectorBrowseButton = '#upload-browse-button'
const messageNoImage = 'Bitte ein Bild auswählen'

function uploadButtonEvents() {
  $(selectorTextfield).click(() => {
    $(selectorUserfile).click()
  })

  $(selectorBrowseButton).click(() => {
    $(selectorUserfile).click()
  })

  $(selectorUserfile).change(function() {
    const uploadPath = $(this).val()
    const filename = uploadPath.replace(/^.*\\/, '')
    $(selectorTextfield).val(filename)
  })
}

function checkForSelectedFile() {
  $(document).on('submit', selectorFormular, () => {
    if (!document.getElementById(idUserfile).value) {
      $(selectorTextfield).val(messageNoImage)
    }
  })
}

function init() {
  uploadButtonEvents()
  checkForSelectedFile()
}

export default {
  init
}



// WEBPACK FOOTER //
// ./app/components/form/formView.js